import React from 'react';
import { cn } from '../../lib/classNames';
import { tableBase, tableHead, tableRow, tableScroll, tableTd, tableTh, tableWrap } from '../../lib/uiClasses';

export const Table = ({ className, children }) => (
  <div className={cn(tableWrap, className)}>
    <div className={tableScroll}>
      <table className={tableBase}>{children}</table>
    </div>
  </div>
);

export const TableHead = ({ className, ...props }) => (
  <thead className={cn(tableHead, className)} {...props} />
);

export const TableRow = ({ className, ...props }) => (
  <tr className={cn(tableRow, className)} {...props} />
);

export const TableHeaderCell = ({ className, ...props }) => (
  <th className={cn(tableTh, className)} {...props} />
);

export const TableCell = ({ className, ...props }) => (
  <td className={cn(tableTd, className)} {...props} />
);
